import { render, staticRenderFns } from "./StyleDialogContentClasses.vue?vue&type=template&id=2dbd17f0&"
import script from "./StyleDialogContentClasses.vue?vue&type=script&lang=js&"
export * from "./StyleDialogContentClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports